module.exports = __webpack_public_path__ + "img/1517104457.7c8a4d71.jpg";